import axios from 'axios';
import Token from "./Token";

export default class Api {
    static baseUrl() {
        return '/api';
    }

    static async call(method, path, options = {}) {
        options = {
            method,
            url: this.baseUrl() + path,
            timeout: 0,
            responseType: 'json',
            ...options,
            headers: {
                ...options.headers
            }
        };

        const token = await Token.get();
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }

        return axios.request(options).then(async res => {
            let authorizationRenew = res.headers.authorization;
            if (authorizationRenew) {
                let token = authorizationRenew.replace('Bearer ', '');
                Token.store(token);
            }

            return res.data;
        });
    }

    static async get(path, params, options = {}) {
        return Api.call('GET', path, {
            params,
            ...options
        });
    }

    static async post(path, data, options = {}) {
        return Api.call('POST', path, {
            data,
            ...options
        });
    }

    static async put(path, data, options = {}) {
        return Api.call('PUT', path, {
            data,
            ...options
        });
    }

    static async delete(path, options = {}) {
        return Api.call('DELETE', path, options);
    }

}
